// extracted by mini-css-extract-plugin
export default {"container":"AccountSocial_container__y2KbU","column":"AccountSocial_column__Bk7eD"};